
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { CRMData } from "../types";

export const useDataFetching = () => {
  const [crmData, setCRMData] = useState<CRMData[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchCRMData();
  }, []);

  const fetchCRMData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // Use the secure function instead of direct view access
      const { data, error } = await supabase
        .rpc('get_crm_data');
      
      if (error) {
        throw error;
      }
      
      setCRMData(data || []);
    } catch (err) {
      console.error("Erreur lors de la récupération des données CRM:", err);
      setError("Impossible de récupérer les données CRM. Vous devez être administrateur pour accéder à ces données.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    crmData,
    isLoading,
    error,
    fetchCRMData,
  };
};
